import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { skillTypeOptions, targetAudienceOptions, difficultyLevels } from "./constants";

export function ManualCreatePlanDialog({
  open, onOpenChange, formData, loading,
  onFormChange, onSubmit, onLoadTemplate
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="manual-create-plan-dialog" className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Create Training Plan Manually</DialogTitle>
          <DialogDescription>Create a custom training plan with your own content</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <Label htmlFor="manual-title">Plan Title *</Label>
            <Input
              id="manual-title"
              value={formData.title}
              onChange={(e) => onFormChange({ ...formData, title: e.target.value })}
              placeholder="Enter plan title"
              className="mt-1"
            />
          </div>

          <div>
            <Label htmlFor="manual-description">Description *</Label>
            <Textarea
              id="manual-description"
              value={formData.description}
              onChange={(e) => onFormChange({ ...formData, description: e.target.value })}
              placeholder="Brief description of the training plan"
              className="mt-1"
              rows={3}
            />
          </div>

          <div>
            <Label htmlFor="manual-duration">Duration (weeks)</Label>
            <Input
              id="manual-duration"
              type="number" min="1" max="52"
              value={formData.duration_weeks}
              onChange={(e) => onFormChange({ ...formData, duration_weeks: parseInt(e.target.value) })}
              className="mt-1"
            />
          </div>

          <div>
            <Label htmlFor="skill-type">Type of Skill Being Developed *</Label>
            <select
              id="skill-type"
              value={formData.skill_type}
              onChange={(e) => onFormChange({ ...formData, skill_type: e.target.value })}
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-emerald-500"
            >
              <option value="">Select a skill type...</option>
              {skillTypeOptions.map((skill) => (
                <option key={skill} value={skill}>{skill}</option>
              ))}
            </select>
          </div>

          <div>
            <Label htmlFor="difficulty-level">Difficulty Level</Label>
            <select
              id="difficulty-level"
              value={formData.difficulty_level}
              onChange={(e) => onFormChange({ ...formData, difficulty_level: e.target.value })}
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-emerald-500"
            >
              {difficultyLevels.map((level) => (
                <option key={level.value} value={level.value}>{level.label}</option>
              ))}
            </select>
          </div>

          <div>
            <Label htmlFor="target-audience">Target Audience</Label>
            <select
              id="target-audience"
              value={formData.target_audience}
              onChange={(e) => onFormChange({ ...formData, target_audience: e.target.value })}
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-emerald-500"
            >
              <option value="">Select target audience...</option>
              {targetAudienceOptions.map((audience) => (
                <option key={audience} value={audience}>{audience}</option>
              ))}
            </select>
          </div>

          <div>
            <div className="flex justify-between items-center mb-2">
              <Label htmlFor="manual-content">Plan Content *</Label>
              <Button
                type="button" variant="outline" size="sm"
                onClick={onLoadTemplate}
                disabled={loading}
                className="text-xs"
              >
                Load Comprehensive Template
              </Button>
            </div>
            <Textarea
              id="manual-content"
              value={formData.plan_content}
              onChange={(e) => onFormChange({ ...formData, plan_content: e.target.value })}
              placeholder="Enter the detailed training plan content, or click 'Load Comprehensive Template' for a structured guide..."
              className="mt-1"
              rows={8}
            />
            <p className="text-xs text-gray-500 mt-1">
              Tip: Use the template button to load a comprehensive guide. Customize it for your specific needs!
            </p>
          </div>

          <Button
            data-testid="submit-manual-plan-btn"
            onClick={onSubmit}
            disabled={loading}
            className="w-full bg-sky-600 hover:bg-sky-700"
          >
            {loading ? "Creating..." : "Create Plan"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
